import { Modal } from '@/components/ui/Modal';
import { Icon } from '@/components/ui/Icon';
import { useSipStore } from '../stores/sipStore';

/**
 * חלונית חוסמת לכשל מיקרופון.
 *
 * עד לתיקון הזה כשל ב-getUserMedia נבלע ב-catch ריק, וה-state נקבע
 * ל-'ringing-out' בכל מקרה — כך שהמסך הציג "מחייג" עם טיימר קפוא על 0:00
 * בזמן שאף INVITE לא נשלח לשרת. אומת בפרודקשן: אפס תעבורת SIP מהשלוחה
 * בזמן הלחיצה, בעוד שהרישום עצמו תקין.
 *
 * כל עוד `micError` מלא, dial() מסרב לחייג — כדי שלא ייווצר "מחייג" מדומה נוסף.
 */
export function MicBlockedModal() {
  const micError = useSipStore((s) => s.micError);
  const clearMicError = useSipStore((s) => s.clearMicError);

  if (!micError) return null;

  return (
    // 3000 = מעל הכל: כרטיס לקוח (1300), סרגל פיקוח (1250), צ'אט צף (1200),
    // סופטפון צף (1100) וטוסטים (2000). בלי זה החלונית נפתחת מתחת לכרטיס
    // הלקוח — בדיוק המסך שממנו מחייגים — והמשתמש לא רואה שהחיוג נחסם.
    <Modal isOpen onClose={clearMicError} size="sm" zIndex={3000}>
      <div className="stack" style={{ padding: 4, gap: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: '50%',
              background: 'var(--danger-soft)',
              color: 'var(--danger)',
              flexShrink: 0,
            }}
          >
            <Icon name="mic-off" />
          </span>
          <h2 style={{ margin: 0, fontSize: 'var(--t-lg)' }}>החיוג נחסם — אין גישה למיקרופון</h2>
        </div>

        <p style={{ margin: 0, lineHeight: 1.6 }}>{micError}</p>

        <p style={{ margin: 0, color: 'var(--muted)', fontSize: 'var(--t-xs)', lineHeight: 1.6 }}>
          שיחה יוצאת דורשת מיקרופון. עד שההרשאה תתוקן לא תתבצע שיחה — קודם הלחיצה
          על "חייג" הציגה "מחייג" בלי שיצאה שיחה בפועל.
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 8 }}>
          <button type="button" className="btn btn-primary" onClick={clearMicError}>
            הבנתי
          </button>
        </div>
      </div>
    </Modal>
  );
}
